<template>
  <div>
    <v-btn
      @click.stop="drawer = !drawer"
      v-show="!drawer"
      style="bottom:65px;"
      absolute
      fixed
      dark
      fab
      bottom
      right
      color="primary"
    >
      <v-badge :content="userCount" bordered light>
        <v-icon>mdi-account-multiple</v-icon>
      </v-badge>
    </v-btn>
    <v-navigation-drawer
      v-model="drawer"
      right
      absolute
      hide-overlay
      persistent
      style="top:65px"
      width="225px"
    >
      <v-data-table
        sort-by="lastName"
        :sort-desc="false"
        class="online-user-table"
        :headers="headers"
        :items="onlineUsers"
        dense
        :hide-default-footer="true"
        :disable-pagination="true"
      >
        <template v-slot:top>
          <v-toolbar dense flat>
            <v-icon>mdi-account-multiple</v-icon>
            <v-spacer></v-spacer>
            <v-toolbar-title>Online ({{ userCount }})</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.stop="drawer = false">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
        </template>
        <template v-slot:item.lastName="{ item }">
          <small class="online-user-name d-inline-block text-truncate"
            ><v-icon
              v-if="item.role === 'authenticated'"
              class="auth-lock-icon"
              small
              >mdi-lock</v-icon
            >
            {{ item.firstName }} {{ item.lastName }}</small
          >
        </template>
        <template v-slot:header.voted>
          <v-icon small>mdi-vote</v-icon>
        </template>
        <template v-slot:header.voted>
          <v-icon small>mdi-vote</v-icon>
        </template>
        <template v-slot:item.voted="{ item }">
          <v-icon small v-if="item.voted">mdi-check</v-icon>
        </template>

        <template v-slot:item.action="{ item }">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="dismissUser(item)">
                <v-list-item-title>Dismiss</v-list-item-title>
              </v-list-item>
              <v-list-item @click="toggleScrutineer(item)">
                <v-list-item-title
                  >Scrutineer
                  <v-icon small v-if="item.scrutineer"
                    >mdi-check</v-icon
                  ></v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["showOnline"],
  data() {
    return {
      headers: [
        {
          text: "Voted",
          align: "center",
          value: "voted",
          width: "10%",
          divider: true
        },

        {
          text: "Name",
          align: "start",
          value: "lastName"
        },
        {
          text: "",
          align: "center",
          value: "action",
          sortable: false
        }
      ],
      //onlineUsers: [],
      drawer: false,
      mini: true
    };
  },
  computed: {
    userCount: function() {
      return this.onlineUsers.length || "0";
    },
    ...mapState(["onlineUsers"])
  },

  methods: {
    dismissUser(user) {
      this.$socket.client.emit("dismissUser", user._id);
    },
    toggleScrutineer(user) {
      this.$socket.client.emit("toggleScrutineer", user._id);
    }
  }
};
</script>

<style>
/*
.v-list-item--dense,
.v-list--dense .v-list-item {
  min-height: 20px;
  height: 0px;
}
*/
/*
.v-list-item--dense .v-list-item__icon,
.v-list--dense .v-list-item .v-list-item__icon {
  height: 20px;
  margin-top: 0px;
  margin-bottom: 0px;
}
*/

.online-user-table > .v-data-table__wrapper > table > tbody > tr > td {
  height: 12px;
  padding: 0;
}

.online-user-name {
  vertical-align: middle;
  max-width: 130px;
  margin: 0;
  padding: 0 6px;
}

.online-user-table > .v-data-table__wrapper > table > thead > tr > th {
  white-space: nowrap;
  padding: 0 6px;
}

.online-user-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th
  > i:nth-child(2) {
  display: none;
}

.auth-lock-icon {
  font-size: 11px !important;
}
</style>
